import { useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import Input from '../../../../../../components/Input/Input';
import { Button, Icon } from '../../../../../../components';
import FormLayout from '../../../../layout/FormLayout/FormLayout';
import Select from '../../../../../../components/Select/Select';
import { Icons } from '../../../../../../components/Icon/Icon';
import { createPortal } from 'react-dom';
import FormCollapsableRow from '../../../../layout/FormCollapsableRow/FormCollapsableRow';

const LicenseCreateForm = ({ countries, onSave, onClose }: any) => {
    const [items, setItems] = useState<any[]>([{}]);

    const handleInputChange = (index: number, prop: string) => (event: any) => {
        let tmp = [...items];
        tmp[index] = { ...tmp[index], [prop]: event.target.value };
        setItems(tmp);
    };

    const handleSelectChange = (index: number, prop: string) => (value: any) => {
        let tmp = [...items];
        tmp[index] = { ...tmp[index], [prop]: value };
        setItems(tmp);
    };

    const handleAddItem = () => {
        setItems([
            ...items.map((item: any) => ({ ...item, closed: true })),
            {
                value: uuidv4(),
                label: '',
                authorityManual: '',
            },
        ]);
    };

    const handleRemoveItem = (index: number) => () => {
        const tmp = [...items];
        tmp.splice(index, 1);
        setItems(tmp);
    };

    return (
        <>
            {createPortal(
                <FormLayout
                    title={'Licenses and approval'}
                    description={'Please provide the licence name, location and regulatory authority that issued it. '}
                    isAbsolute={true}
                    minSize={'md'}
                    footerMain={
                        <Button disabled={!!items.find((i) => !i.label)} onClick={onSave('licenses', items)}>
                            Upload
                        </Button>
                    }
                    footerAdditional={
                        <Button
                            secondary={true}
                            outlined={true}
                            type={'button'}
                            before={<Icon icon={Icons.add} />}
                            onClick={handleAddItem}
                            minWidth={true}
                            disabled={!!items.find((i) => !i.label)}
                        >
                            Add License
                        </Button>
                    }
                    onClose={onClose}
                >
                    {items.map((item: any, index: number) => (
                        <>
                            {item.closed ? (
                                <FormCollapsableRow
                                    titleLabel={`${index + 1}. Licence & Approval `}
                                    descriptionLabel={[item.domicile?.label, item.label]
                                        .filter((v) => !!v)
                                        .join(' // ')}
                                    hideHeader={false}
                                    useGrid={false}
                                    labelFullWidth={true}
                                    key={index}
                                    afterLabel={
                                        <button
                                            style={{
                                                minWidth: 32,
                                            }}
                                            type={'button'}
                                            onClick={handleRemoveItem(index)}
                                        >
                                            <Icon icon={Icons.closeRounded} />
                                        </button>
                                    }
                                >
                                    <Input
                                        onChange={handleInputChange(index, 'label')}
                                        value={item.label}
                                        style={'text'}
                                        max={100}
                                    >
                                        Full name
                                    </Input>
                                    <Input
                                        onBlur={handleInputChange(index, 'authorityManual')}
                                        style={'secondary'}
                                        value={item.authorityManual}
                                    >
                                        Regulatory authority
                                    </Input>
                                    <Select
                                        value={item.domicile}
                                        onChange={handleSelectChange(index, 'domicile')}
                                        options={countries}
                                        valueKey={'domicileId'}
                                        labelKey={'domicileName'}
                                        style={'secondary'}
                                        placeholder={'Choose domicile'}
                                    >
                                        Domicile
                                    </Select>
                                </FormCollapsableRow>
                            ) : (
                                <div
                                    key={index}
                                    style={{
                                        marginTop: index === 0 ? 0 : 40,
                                    }}
                                >
                                    <Input
                                        onChange={handleInputChange(index, 'label')}
                                        value={item.label}
                                        style={'text'}
                                        max={100}
                                    >
                                        Full name
                                    </Input>
                                    <Input
                                        onBlur={handleInputChange(index, 'authorityManual')}
                                        style={'secondary'}
                                        value={item.authorityManual}
                                    >
                                        Regulatory authority
                                    </Input>
                                    <Select
                                        value={item.domicile}
                                        onChange={handleSelectChange(index, 'domicile')}
                                        options={countries}
                                        valueKey={'domicileId'}
                                        labelKey={'domicileName'}
                                        style={'secondary'}
                                        placeholder={'Choose domicile'}
                                    >
                                        Domicile
                                    </Select>
                                </div>
                            )}
                        </>
                    ))}
                </FormLayout>,
                document && document.getElementById('formWrapper')!,
            )}
        </>
    );
};

export default LicenseCreateForm;
